module.exports = {
    DataBaseConnection: require('./lib/controller/DataBaseConnection').DataBaseConnection,
    Restaurant: require('./lib/model/Restaurant').Restaurant,
    Catalog: require('./lib/model/Catalog').Catalog,
    Order: require('./lib/model/Order').Order,
    Product: require('./lib/model/Product').Product,
    Price: require('./lib/model/Price').Price,
    Size: require('./lib/model/Size').Size,
    Upgrade: require('./lib/model/Upgrade').Upgrade,
    ProductOption: require('./lib/model/ProductOption').ProductOption,
    ProductSelection: require('./lib/model/ProductSelection').ProductSelection,
    Properties: require('./lib/model/Properties').Properties,
    Media: require('./lib/model/Media').Media,
    LineItem: require('./lib/model/LineItem').LineItem,
    Method: require('./lib/model/Method').Method,
    Availability: require('./lib/model/Availability').Availability,
    CatalogSelection: require('./lib/model/CatalogSelection').CatalogSelection,
    CatalogOption: require('./lib/model/CatalogOption').CatalogOption,
    Category: require('./lib/model/Category').Category,
    Additive: require('./lib/model/Additive').Additive,
    Shipping: require('./lib/model/Shipping').Shipping,
    RealTimeData: require('./lib/model/RealTimeData').RealTimeData,
    Discount: require('./lib/model/Discount').Discount,
    RenderedOrder: require('./lib/util/RenderedOrder').RenderedOrder,
    RenderedLineItem: require('./lib/util/RenderedLineItem').RenderedLineItem,
    RenderedAvailability: require('./lib/util/RenderedAvailability').RenderedAvailability,
    OrderList: require('./lib/util/OrderList').OrderList,
    MetafieldDefinition: require('./lib/model/MetafieldDefinition').MetafieldDefinition,
    PaypalSettings: require('./lib/model/PaypalSettings').PaypalSettings,
    MailTemplate: require('./lib/model/MailTemplate').MailTemplate,
    TriggerFinder: require('./lib/util/TriggerFinder').TriggerFinder,
    RenderedMail: require('./lib/util/RenderedMail').RenderedMail,
    DiscountList: require('./lib/util/DiscountList').DiscountList,
    Message: require('./lib/model/Message').Message,
    MessageList: require('./lib/util/MessageList').MessageList,
    RenderedOrderList: require('./lib/util/RenderedOrderList').RenderedOrderList,
    ReactiveOrder: require('./lib/model/ReactiveOrder').ReactiveOrder,
    PrintLayout: require('./lib/model/PrintLayout').PrintLayout,
    RenderedPrintLayout: require('./lib/util/RenderedPrintLayout').RenderedPrintLayout,
    PhoneLink: require('./lib/util/PhoneLink').PhoneLink
}
    